import Auth from './containers/Auth/Auth';
import LostPassword from './containers/Auth/LostPassword';
import NewPassword from './containers/Auth/NewPassword';
import Activation from './containers/Auth/Activation';
import { authReducer } from './containers/Auth/reducer';
import {
  USER_COOKIE,
  LOGIN_USER,
  LOGOUT_USER,
  UPDATE_USER_DATA,
} from './containers/Auth/constants';

export {
  Auth,
  LostPassword,
  NewPassword,
  Activation,
  authReducer,
  USER_COOKIE,
  LOGIN_USER,
  LOGOUT_USER,
  UPDATE_USER_DATA,
};
